export function convertResponseJsonToObject(responseData) {
    const convertedData = {};
    for (const key in responseData) {
        if (Object.hasOwnProperty.call(responseData, key)) {
            convertedData[key] = responseData[key];
        }
    }
    return convertedData;
}